export enum Communication {
	AiCall = 'ai_call',
	Bitrix24 = 'bitrix24',
}
